import React from "react";

import svg from "../../assets/images/icons/Form Controls/checkbox.svg";

export const CheckboxIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Checkbox"}
    />
);
